module.exports = __webpack_public_path__ + "static/media/michele.8fa9b36b.jpeg";